import React from 'react'
import { connectStateResults } from 'react-instantsearch-dom'

const connectResults = (WrappedComponent: any) => {
  const StateResults = connectStateResults(
    // @ts-ignore
    ({ props, searchState, searchResults, allSearchResults }) => {
      const { query } = searchState
      const nbHits = (searchResults && searchResults.nbHits) || 0
      const hasResults = nbHits > 0

      return (
        <WrappedComponent
          {...props}
          nbHits={nbHits}
          query={query}
          hasResults={hasResults}
          allSearchResults={allSearchResults}
        />
      )
    },
  )

  const StateResultsComponentTest = (props: any) => <StateResults {...props} />
  StateResultsComponentTest.displayName = 'StateResultsComponentTest'
  return StateResultsComponentTest
}

export default connectResults
